import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useMediaQuery, useTheme } from '@mui/material';

export const NotificationMessage = ({ selectedMessage, open, handleClose }: { selectedMessage: string, open: boolean, handleClose: () => void }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            sx={{
                '& .MuiDialog-paper': {
                    minWidth: isMobile ? '90%' : '700px',
                    maxWidth: isMobile ? '90%' : '700px',
                    margin: isMobile ? 0 : undefined,
                    borderRadius: isMobile ? 0 : undefined,
                }
            }}
        >
            <DialogTitle id="responsive-dialog-title">
                <h4>Notification Message</h4>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <div
                        dangerouslySetInnerHTML={{ __html: selectedMessage }}
                    />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button type='button' className='btn btn-primary btn-sm' onClick={handleClose} autoFocus>
                    Close
                </button>
            </DialogActions>
        </Dialog>
    );
};
